import { axios } from "@/plugins/axios";
import { getDataString } from "@/utils";

function getDokbox() {
    return axios.post("?Mode=MeinServicebereich&Function=GetDokbox", "");
}

// parameters:
// orderBy, // FileName,FileDate
// limitStart,
// limit,
// limitPrivate,
// limitPublic,
// limitYears,
// limitCategories,
// limitSearch;
function getDokboxFiles(formData = {}) {
    let data = {};
    data = Object.assign({}, formData);

    data.orderBy = "FileDate";

    const dataString = getDataString(data);

    // if (formData.limitYears !== null) {
    //     for (let arraykey in formData.limitYears) {
    //         // console.log(data.limitYears[arraykey]);
    //         dataString += "&limitYears[]=" + formData.limitYears[arraykey];
    //     }
    // }

    // console.log(data.limitYears);
    return axios.post(
        "?Mode=MeinServicebereich&Function=GetDokboxFiles",
        dataString
    );
}

function getDokboxFile(dokfileid) {
    return axios.post(
        "?Mode=MeinServicebereich&Function=GetDokboxFile",
        "fileId=" + dokfileid
    );
}

// parameters:
// beraterinfo,
// beratertext,
// name,
// categoryId,
// is360,
// desc,
// ispublic,
// file,
function addDokboxFile(data = {}) {
    const { date } = data;
    let changedData = Object.assign({}, data);
    changedData.date = date.slice(0, 10);
    let formData = new FormData();
    for (let key in changedData) {
        formData.append(key, changedData[key]);
    }
    return axios.post(
        "?Mode=MeinServicebereich&Function=AddDokboxFile",
        formData
    );
}

// parameters:
// name
// categoryId
// desc
// ispublic
// fileId
function modifyDokboxFile(data = {}) {
    const { date } = data;
    let changedData = Object.assign({}, data);
    changedData.date = date.slice(0, 10);
    let formData = new FormData();
    for (let key in changedData) {
        formData.append(key, changedData[key]);
    }
    return axios.post(
        "?Mode=MeinServicebereich&Function=ModifyDokboxFile",
        formData
    );
}

function deleteDokboxFile(fileid) {
    return axios.post(
        "?Mode=MeinServicebereich&Function=DeleteDokboxFile",
        "fileId=" + fileid
    );
}

function shareFile(fileid) {
    return axios.post(
        "?Mode=MeinServicebereich&Function=ShareFile",
        "fileId=" + fileid
    );
}

function unshareFile(fileid) {
    return axios.post(
        "?Mode=MeinServicebereich&Function=UnshareFile",
        "fileId=" + fileid
    );
}

function sendFileToCoach(fileid, beratermessage) {
    var data = {};
    data.fileid = fileid;
    data.beratermessage = beratermessage;
    return axios.post(
        "?Mode=MeinServicebereich&Function=SendFileToCoach",
        data
    );
}

function showDokboxFile(params) {
    return axios.post(
        "?Mode=MeinServicebereich&Function=ShowDokboxFile&FileId=" +
            params.fileId +
            "&Thumb=" +
            params.thumb,
        undefined,
        {
            responseType: "arraybuffer",
        }
    );
}

export {
    getDokbox,
    getDokboxFiles,
    getDokboxFile,
    addDokboxFile,
    modifyDokboxFile,
    deleteDokboxFile,
    shareFile,
    unshareFile,
    sendFileToCoach,
    showDokboxFile,
};
